import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import { OptionsItem, SubTitle, Information, Point, InfoFixeLine } from './';
import DateFormat from '../../lib/date/DateFormat';
import moment from 'moment';
import MispariIcon from '../Icons/MispariIcon';
import { Help } from '../../images';
import Debug from '../../lib/debug/Debug';
class MobileLineItem extends Component {
  constructor() {
    super();
    this.state = {
      programs: [],
      arrStatus: true,
    };
    this.arrClose = this.arrClose.bind(this);
    this.arrOpen = this.arrOpen.bind(this);
  }
  arrClose() {
    this.setState({
      arrStatus: false,
    });
  }
  arrOpen() {
    this.setState({
      arrStatus: true,
    });
  }
  render() {
    const { translate, currentLanguage, isActive, userProductId, title, subscription1, Data, subtitle1, subscription2, subtitle2, createdDate, simNumber, options, isFrozen, bundleName, hasFutureFreeze, futureFreezeStartingDate, currentFreezeEndDate, forwardData, hasFutureMispari, hasMispariActive, isPendingActivation, hasPendingUpgrade, pendingUpgradeInformations, activationLink, pendingMigrationInformation, hasOngoingTransfer, canActivateMispari, balance, hasApnFilter, isEsim, statusEsim, lastIccidImei, showOptions } = this.props
    let active = isActive ? translate("active") : translate("inactive");
    let isActivePoint = isActive ? 'ACTIVE' : 'INACTIVE';
    let cssStatusESim = "";
    let labelStatusEsimtatus = "";
    let esimStatus = "";
    
    if (isFrozen) {
      active = translate("freeze")
      isActivePoint = 'FREEZE';
    }
    if (isPendingActivation) {
      active = translate("pending-activation")
      isActivePoint = 'PENDING';
    }
    if (isPendingActivation && !activationLink) {
      active = translate("activation-in-progress")
    }
    if (hasOngoingTransfer) {
      active = translate('awaiting-migration')
      isActivePoint = 'AWAITING';
    }
    if (statusEsim == "bpp_enabled") {
      cssStatusESim = "status-enabled"
      labelStatusEsimtatus = "ON"
      esimStatus = "bpp_enabled"
    } else if (statusEsim == "bpp_disabled") {
      cssStatusESim = "status-disabled"
      esimStatus = "bpp_disabled"
      labelStatusEsimtatus = "OFF"
    } else if (statusEsim == "bpp_deleted" || statusEsim == "annatel_auto_swimSwap_notReusable" || statusEsim == "annatel_mail_reused" || statusEsim == "profile_reuse_to_reusable"  ) {
      cssStatusESim = "status-deleted"
      labelStatusEsimtatus = translate('esim-deleted')
      esimStatus = "bpp_deleted"
    }

    // Collapse block 
    const collapseStatus = this.state.arrStatus ? <div className="card-footer collapsed" data-toggle="collapse" data-target={`#${userProductId}`} aria-expanded="true" style={{ display: !collapseStatus }} onClick={this.arrClose} >
      <div className="collapse-indicator " >
        {translate('more-information')}
      </div>
      <i className="material-icons arrow-footer" >
        keyboard_arrow_down
      </i>
    </div>
      :
      <div className="card-footer collapsed" data-toggle="collapse" data-target={`#${userProductId}`} aria-expanded="true" style={{ display: !collapseStatus }} onClick={this.arrOpen} >
        <div className="collapse-indicator ng-binding" >
          {translate('close-information')}
        </div>
        <i className="material-icons arrow-footer" >
          keyboard_arrow_up
        </i>
      </div>;
    // End collapse block

    const bundle = bundleName ?
      <div>
        <span className="">{`${translate('is-in-bundle')}: `}</span>
        <Link className="service-title" to={`/${currentLanguage}/services/bundles/${Data.bundleId}`}>
          <span className="badge badge-pill badge-info">{bundleName}</span>
        </Link>
      </div>
      : '';

    const freezeEndDateBadge = isFrozen && currentFreezeEndDate ?
      <span className="badge badge-pill badge-futureFreeze">{`${translate('end-of-freeze-planned-on')}` + ': ' + moment(currentFreezeEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</span> : '';

    const futureFreezeBadge = hasFutureFreeze ?
      <span className="badge badge-pill badge-futureFreeze">{`${translate('has-future-freeze')}` + ': ' + moment(futureFreezeStartingDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</span> : '';

    const futureMispariWithEndDateBadge = hasFutureMispari && forwardData.endDate ?
      <span className="badge badge-pill badge-futureMispari">  <MispariIcon fill={'white'} />
        {' ' + `${translate('mispari-planned')}` + `${translate('mispari-forward-to')}` + forwardData.number + ' ' + `${translate('mispari-with-end-planned-on')}` + moment(forwardData.startingDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm')
          + `${translate('mispari-planned-until')}` + moment(forwardData.endDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm')}</span>
      : '';

    const futureMispariWithoutEndDateBadge = hasFutureMispari && !forwardData.endDate ?
      <span className="badge badge-pill badge-futureMispari">  <MispariIcon fill={'white'} />
        {' ' + `${translate('mispari-planned')}` + `${translate('mispari-forward-to')}` + forwardData.number + ' ' + `${translate('mispari-without-end-planned-on')}` + moment(forwardData.startingDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm')}
      </span>
      : '';

    const hasMispariActiveBadge = hasMispariActive && forwardData ?
      <span className="badge badge-pill badge-activeMispari"> <MispariIcon fill={'white'} />
        {' ' + `${translate('has-active-mispari')}` + `${translate('mispari-forward-to')}` + forwardData.number + ' ' +
          (forwardData.endDate ? ' ' + `${translate('mispari-ends-on')}` + ' ' + moment(forwardData.endDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm') : '')}</span> : '';

    const upgradeInformations = hasPendingUpgrade ?
      <div>
        <span className="badge badge-pill badge-primary">{pendingUpgradeInformations}</span>
      </div>
      : '';
    const activationLinkElement = activationLink ?
      <div style={{ paddingTop: "8px" }}>
        <Link className="service-title" to={activationLink} target="_blank">
          <h5><span className="badge badge-pill badge-info">{translate('activate-my-line')}</span></h5>
        </Link>
      </div> :
      '';
    const lastStatusEsim = isEsim ?
      <div className="form-group">
        <div className="details-esim">
          <span className="badge badge-pill badge-inverse">{translate('active-esim')}</span>
          <div className={cssStatusESim}></div>
          <div className="label-esim"> {labelStatusEsimtatus}</div>
          <span class="btn-action" data-toggle="modal" data-target={`#infos-esim-${esimStatus}`}><img alt={translate('help-esim')} className="help-esim" src={Help} /></span>
        </div>
      </div>
      : '';

    return (
      <div className="card card-service card-service-active">
        <div className="card-header">
          <div className="row">
            <div className="col-8">
              {/* title => displays the primary phone Number */}
              <h4 className="service-title"><span>{title}</span></h4>
              <div>
                {bundle} {futureFreezeBadge} {freezeEndDateBadge} {hasMispariActiveBadge} {futureMispariWithEndDateBadge} {futureMispariWithoutEndDateBadge}
              </div>
            </div>
            <div className="col-4 text-right" id='MyServices'>
              {Point(isActivePoint)}
              <div className="service-status-name">{active}</div>
            </div>
          </div>
          <div className='row'>
            <div className="col" >
              <div className="service-subscription">
                {SubTitle(subscription1, subtitle1)}
                {SubTitle(subscription2, subtitle2)}
                {upgradeInformations}
                {activationLinkElement}
              </div>
            </div>
          </div>
          <div className="collapse" aria-expanded="true" id={userProductId}>

            <div className="card-block service-detail">
              <div className="row">
                <div className="col-md-7">
                  <h4 className="service-detail-title">{translate('management-of-my-subscription')}</h4>
                  {OptionsItem(title, translate, options, userProductId, hasFutureFreeze, isFrozen, currentLanguage, hasFutureMispari, hasMispariActive, canActivateMispari, balance, Data)}
                </div>
                <div className="col-md-5">
                  <h4 className="service-detail-title">{translate('other-information')}</h4>
                  <div className="form form-line">
                    {InfoFixeLine(Data, translate('device'), translate('mac_address'))}                                        
                    {lastStatusEsim}
                    {lastIccidImei}
                    {Information(translate('activation-date'), pendingMigrationInformation ? null : <DateFormat date={createdDate} />)}
                    {isEsim ? '' : Information(translate('sim-number'), simNumber)}                                                                                                                           
                    {Information(translate('sim-number'), pendingMigrationInformation ? pendingMigrationInformation.iccid : null)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          {showOptions ? collapseStatus : ''}
        </div>

        <div class="modal fade modal-form-control-line" id="infos-esim-bpp_enabled">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Information</h6>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <p>{translate('info-esim-on-p1')}</p>
                </div>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade modal-form-control-line" id="infos-esim-bpp_disabled">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Information</h6>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <p>{translate('info-esim-off-p1')}</p>
                  <p>{translate('info-esim-off-p2')}</p>
                  <p><span className="space">{translate('info-esim-off-p3')}</span></p>
                  <p><span className="space">{translate('info-esim-off-p4')}</span></p>
                  <p><span className="space">{translate('info-esim-off-p5')}</span></p>
                </div>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade modal-form-control-line" id="infos-esim-bpp_deleted">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Information</h6>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                <p>{translate('info-esim-deleted-p1')}</p>
                <p>{translate('info-esim-deleted-p2')}</p>
                <p>{translate('info-esim-deleted-p3')}<a href={`${translate('link-whatapp-deleted')}`}>{translate('link-whatapp-deleted')}</a>.</p> 
                <p>{translate('info-esim-deleted-p4')}</p> 
                </div>
              </div>
              <div class="modal-footer">
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

MobileLineItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileLineItem);

export default MobileLineItem;



// WEBPACK FOOTER //
// ./src/components/MyServices/MobileLineItem.js